import { gql } from "@apollo/client";

const PROFILE_STEAM_LOOKUP = gql`
  query ProfileSteamLookup($query: String!) {
    profile(query: $query) {
      __typename
      ... on UnclaimedProfile {
        id
        username
        avatarUrl
      }
      ... on User {
        id
        username
        avatarUrl
      }
    }
  }
`;

export { PROFILE_STEAM_LOOKUP };
